import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { MovementClient } from '@frontend/stock/api';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useMovement:request': CustomEvent<string>;
    }
}

const REQUEST_MOVEMENT_EVENT = 'useMovement:request';
const STORAGE_KEY = 'MVMNT_REQ';

export function movementRequest(movementId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_MOVEMENT_EVENT, { detail: movementId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function MovementResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_MOVEMENT_EVENT, EntityType.MOVEMENT, (ids) => MovementClient.resolveMovements(ids), props.dispatch);
    return <></>;
}
